/**
 * The menu is a list of all the pages and sections on the site.
 *
 * It is used to generate the navbar.
 *
 * It is also used to generate the breadcrumbs.
 * It is also used to generate the footer.
 * It is also used to generate the sitemap.
 * It is also used to generate the robots.txt.
 * It is also used to generate the manifest.json.
 * It is also used to generate the .env.local.
 *
 * Do NOT export the superMenu data-structure from this file,
 * use getter functions from the functions.ts file instead.
 */
export * from "./functions"
export * from "./types"
